;(function() {
  'use strict'

  service.$inject = ["$q", "$log", "$state", "userService", "elementsResource", "glAnalytics", "locationService", "elementFactory", "elementSourcesResource", "pageSelector", "pageService"];
  angular.module('core.services').factory('elementService', service)

  // --------------------

  /* @ngInject */
  function service(
    $q,
    $log,
    $state,
    userService,
    elementsResource,
    glAnalytics,
    locationService,
    elementFactory,
    elementSourcesResource,
    pageSelector,
    pageService
  ) {
    var log = $log.create('elementService')
    var latestSource

    return {
      get: get,
      nearby: nearby,
      search: search,
      // create: create
      setSource: setSource,
      isOwner: isOwner,
      view: view,
    }

    function get(id) {
      return $q(function(resolve, reject) {
        var isSource = id === 'source'
        if (isSource) {
          if (latestSource.elementId) {
            getById(latestSource.elementId).then(onSuccess, onErr)
          } else {
            getBySource().then(onSuccess, onErr)
          }
        } else {
          getById(id).then(onSuccess, onErr)
        }

        function onSuccess(data) {
          elementFactory.transform(data)
          resolve(data)
        }
        function onErr() {
          reject()
        }
      })
    }

    function getBySource() {
      return $q(function(resolve, reject) {
        // var data = {
        //     type: latestSource.type,
        //     elementItemId: latestSource.id
        // };
        elementsResource
          .create(latestSource)
          .success(function(res, data) {
            if (!data.id) {
              return reject()
            }
            elementsResource
              .get({ id: data.id })
              .success(function(resp, data) {
                resolve(data)
              })
              .error(reject)
          })
          .error(reject)
      })
    }

    function getById(id) {
      return $q(function(resolve, reject) {
        elementsResource
          .get({ id: id })
          .success(function(resp, data) {
            resolve(data)
          })
          .error(function() {
            reject()
          })
      })
    }

    function search(query, limit, options) {
      var defaultSearchTypes = [
        'place', // finds via foursquare
        'product', // finds by `title` + `type=product` in elements
        'code', // finds by `sourceId` in elements
        'other', // finds by `title` + `type=other` in elements
      ]
      return $q(function(resolve, reject) {
        options = options || {}
        var typeRequests = []
        _.each(options.types || defaultSearchTypes, function(type) {
          typeRequests.push(
            searchByType(type, query, limit, options.subscriberId)
          )
        })
        $q.all(typeRequests).then(
          function(data) {
            var results = {}
            results.all = []
            results.all = aggregateResults(data)

            // split them into types
            _.each(results.all, function(result) {
              // if type doesnt exist, create it
              if (!results[result.type]) {
                results[result.type] = []
              }
              results[result.type].push(result)
            })
            results.all = prioritiseResults(results.all, query)
            resolve(results)
          },
          function(err) {
            reject(err)
          }
        )
        // location on/off tracking
        if (locationService.latest.encoded) {
          glAnalytics.track('Search', 'location-on')
        } else {
          glAnalytics.track('Search', 'location-off')
        }
      })
      function searchByType(type, query, limit, subscriberId) {
        return $q(function(resolve, reject) {
          elementSourcesResource
            .get({
              type: type,
              query: query,
              limit: limit || 5,
              location: locationService.latest.encoded || {},
              subscriberId: subscriberId,
            })
            .success(function(elements, data) {
              elementFactory.transform(data, true)
              resolve(data)
            })
            .error(function() {
              reject()
            })
        })
      }
      function aggregateResults(data) {
        data = JSON.parse(JSON.stringify(data)) // deep clone
        var aggregateData = []
        var sets = data.length
        var totalCount = 0
        var cursor = 0 // horizontal cursor across each set
        // get total count
        _.each(data, function(item) {
          totalCount += item.length
        })
        // literally pulls an item from the top of each set
        // until they are all merged
        while (aggregateData.length < totalCount) {
          if (data[cursor][0]) {
            aggregateData.push(data[cursor].shift())
          }
          nextCursor()
        }
        function nextCursor() {
          if (cursor === sets - 1) {
            cursor = 0
          } else {
            cursor++
          }
        }
        return aggregateData
      }
      function prioritiseResults(results, query) {
        // Priority order is:
        // 1. Exact match
        // 2. ...everything else
        var newResults = [].concat(removeResults(isExactMatch), results)
        function removeResults(conditionFn) {
          return _.remove(results, function(result) {
            return conditionFn(result)
          })
        }
        function isExactMatch(result) {
          return (
            result.name &&
            result.name.toLowerCase() === query &&
            query.toLowerCase()
          )
        }
        return newResults
      }
    }

    function nearby(limit) {
      return $q(function(resolve, reject) {
        elementSourcesResource
          .get({
            type: 'near',
            limit: limit || 10,
            location: locationService.latest.encoded,
          })
          .success(function(elements, data) {
            elementFactory.transform(data, true)
            resolve(data)
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    function setSource(element) {
      latestSource = {
        // associationType: 'lookUp',
        type: element.type,
        elementId: element.elementId,
        elementItemId: element.elementId ? undefined : element.id,
      }
    }

    function isOwner(element) {
      var user = userService.get()
      var userGroup = user.group && user.group.id
      var elementOwner = element.owner && element.owner.id
      return userGroup && elementOwner && userGroup === elementOwner
    }

    function view(element) {
      // attempt to find an element ID
      var id = getElementID()

      // if no id, its a source we need to create
      if (!id) {
        setSource(element)
        getBySource().then(
          function(element) {
            getPagesAndDoSelection(element.id)
          },
          function() {
            log.error('cannot get element by source')
          }
        )

        // otherwise its a normal element
      } else {
        getPagesAndDoSelection(id)
      }

      function getPagesAndDoSelection(elementId) {
        pageService.getByElement(elementId).then(function(pages) {
          // no pages? go to element
          if (!pages.length) {
            var state = 'app.portal.' + element.type
            return $state.go(state, { id: elementId })
          }

          // one page? go there
          if (pages.length === 1) {
            return $state.go('app.page', {
              id: pages[0].id,
              elementId: elementId,
            })
          }

          // otherwise show page selector
          pageSelector.prompt(pages).then(function(page) {
            $state.go('app.page', { id: page.id, elementId: elementId })
          })
        })
      }

      function getElementID() {
        if (element.extras.isElementSource && element.elementId) {
          return element.elementId
        } else if (element.extras.isElementSource) {
          return null
        } else {
          return element.id
        }
      }
    }
  }
})()
